import ProfileDashboard from '../profile/ProfileDashboard'
import type { ProfileStats } from '../../lib/profileStats'
import type { UserTierState } from '../../lib/tier'

type ProfileTabProps = {
  userId: string | null
  firstName: string
  tier: UserTierState | null
  stats: ProfileStats | null
  onSignOut: () => void
  onUpgrade: () => void
  onSyncCalendar: () => void
  calendarSyncing?: boolean
  onMetricsUpdated?: () => void
  onBillingUpdated?: () => void
  onWellnessDataDeleted?: () => void
}

const ProfileTab = (props: ProfileTabProps) => <ProfileDashboard {...props} />

export default ProfileTab
